import { forwardRef, HTMLProps, Ref } from "react";
import clsx from "clsx";
import { twMerge } from "tailwind-merge";

interface TextProps extends HTMLProps<HTMLTextAreaElement> {
  name: string;
  label: string;
  isSimpleLabel?: boolean;
  disabled?: boolean;
  error?: string;
  className?: string;
}

export const FormText = forwardRef(
  (
    {
      name,
      label,
      isSimpleLabel = false,
      disabled = false,
      error,
      className,
      ...textProps
    }: TextProps,
    ref: Ref<HTMLTextAreaElement>,
  ) => (
    <div>
      {isSimpleLabel && (
        <label htmlFor={`${name}__text`} className="font-bold text-black-70">
          {label}
        </label>
      )}
      <div className="relative">
        <textarea
          {...textProps}
          ref={ref}
          id={`${name}__text`}
          placeholder={textProps.placeholder || ""}
          className={twMerge(
            clsx(
              "peer flex min-h-40 w-full items-center rounded-lg border border-black-16 bg-white-100 p-4 px-4 text-black-100 outline-none hover:border-black-32 disabled:bg-black-4 disabled:text-black-54",
              className,
              !!error && "border-red-100",
            ),
          )}
          disabled={disabled}
        />
        {!isSimpleLabel && (
          <label
            htmlFor={`${name}__text`}
            className={clsx(
              "absolute -top-2 ml-3 bg-white-100 px-1 text-100 text-black-54 duration-300 peer-placeholder-shown:top-[18px] peer-placeholder-shown:text-200 peer-focus:-top-2 peer-focus:text-100",
              !!error && "text-red-100",
            )}
          >
            {label}
          </label>
        )}
      </div>
      {error && <p className="pl-4 pt-1 text-100 text-red-100">{error}</p>}
    </div>
  ),
);
